import React, { FC, useState } from 'react';
import { connect } from 'react-redux';

import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import Times from '@v2/context/Times/page';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { View } from 'react-native';
import {
  MACHINES_PAGES_CONTAINER_STYLES,
  PANEL_VIEW_MODE_WIDTH,
  SCREEN_PADDING_HORIZONTAL,
  SCREEN_PADDING_HORIZONTAL_FOR_ITEM,
  SCREEN_PADDING_HORIZONTAL_FOR_PAGE,
} from '../../../../../common/constants/base.constants';
import { scale } from '@components/frame';
import { Machine } from '@interfaces/machines';
import { isPhone } from '@helpers';

interface NCFileTimesProps {
  selectedItem: Machine;
}

const NCFileTimesComponent: FC<NCFileTimesProps> = ({ selectedItem }) => {
  const [containerWidth, setContainerWidth] = useState<number>(0);

  const ncFileId = selectedItem?.machineStatus?.ncFileId;

  return (
    <MachinesProvider
      // lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      <View
        onLayout={(event) => {
          const { width } = event.nativeEvent.layout;
          setContainerWidth(width);
        }}
        style={[MACHINES_PAGES_CONTAINER_STYLES, { paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_PAGE) }]}
      >
        <Times
          withoutPaddingHorizontal
          ncFileId={ncFileId}
          containerWidth={containerWidth}
          horizontalOffset={SCREEN_PADDING_HORIZONTAL_FOR_PAGE * 2}
          style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}
        />
      </View>
    </MachinesProvider>
  );
};

const NCFileTimes = connect(({ machines: { selectedItem } }) => ({ selectedItem }), {})(NCFileTimesComponent);

export { NCFileTimes };
